module.exports = __webpack_public_path__ + "img/about_01.e6079e79.png";